import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AdminMode } from 'features/admin-mode';
import { Analytic } from 'features/analytic';
import { App } from 'features/app';
import { Blank } from 'features/blank';
import { ClientBlank } from 'features/client-blank';
import { ConsentPage } from 'features/consent-page';
import { Login } from 'features/login';
import { LoginAuth } from 'features/login/login-auth';
import { LoginPassRecovery } from 'features/login/login-pass-recovery';
import { LoginResetPass } from 'features/login/login-reset-pass';
import { NewBlank } from 'features/new-blank';
import ErrorPage from 'features/pages/404';
import ErrorPageRoute from 'features/pages/403';
import { Profile } from 'features/profile';
import { Charts } from 'features/charts';
import { Registration } from 'features/registration';
import { RegistrationConfirm } from 'features/registration/registration-confirm';
import { RegistrationConfirmEmail } from 'features/registration/registration-confirm-email';
import { routes } from 'routes';
import { ProtectedRoute } from 'routes/protect-route';

import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { AppState } from 'store/store';

export const RoutesApp = () => {
	const role = useSelector((state: AppState) => state.userState.user?.role);

	const AdminRoute = ({ role, children }: any) => {
		if (role !== 'ADMIN') {
			return <Navigate to="/error" replace />;
		}
		return children;
	};

	return (
		<>
			<ToastContainer />
			<Routes>
				<Route path={routes.login.path} element={<Login />}>
					<Route path={routes.login_auth.path} element={<LoginAuth />} />
					<Route path={routes.recovery_pass.path} element={<LoginPassRecovery />} />
					<Route path={routes.reset_pass.path} element={<LoginResetPass />} />
				</Route>
				<Route path={routes.registration.path} element={<Registration />}>
					<Route path={routes.registration_confirm.path} element={<RegistrationConfirm />} />
					<Route path={routes.confirm_email.path} element={<RegistrationConfirmEmail />} />
				</Route>
				<Route path={routes.consent.path} element={<ConsentPage />} />
				<Route path="/error" element={<ErrorPageRoute />} />
				<Route element={<ProtectedRoute />}>
					<Route path={routes.root.path} element={<App />}>
						<Route path={routes.blank.path} element={<Blank />} />
						<Route path={routes.profile.path} element={<Profile />} />
						<Route path={routes.charts.path} element={<Charts />} />
						<Route
							path={routes.admin.path}
							element={
								<AdminRoute role={role}>
									<AdminMode />
								</AdminRoute>
							}
						/>
						<Route path={routes.new_blank.path} element={<NewBlank />} />
						<Route path={routes.blank_id.path} element={<NewBlank />} />
						<Route path={routes.client_blank.path} element={<ClientBlank />} />
					</Route>
				</Route>

				<Route path={`${routes.root.path}*`} element={<ErrorPage />} />
			</Routes>
		</>
	);
};
